var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adset-summary__row"},[_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.items),function(item){return _c('span',{key:item[_vm.label],staticClass:"pipe-item flex items-center"},[_vm._v(_vm._s(item[_vm.label]))])}),0),_vm._v(" "),_c('div',{staticClass:"adset-summary__row--type"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }